import { call, put, takeLatest } from '@redux-saga/core/effects'
import { createRoutine } from 'redux-saga-routines'
import { toast } from 'react-toastify'
import * as wikiService from 'services/BuildingWikiService'
import { getApiErrors } from 'utils/errors'

export const fetchWikiRoutine = createRoutine('BUILDING_WIKI_FETCH')
export const refreshWikiRoutine = createRoutine('BUILDING_WIKI_REFRESH')

function* fetchWikiSaga({ payload }) {
  const { bpId } = payload || {}
  try {
    yield put(fetchWikiRoutine.request({ bpId }))
    const { data } = yield call(wikiService.getWiki, { bpId })
    yield put(fetchWikiRoutine.success({ bpId, article: data }))
  } catch (err) {
    const errors = getApiErrors(err)
    yield put(fetchWikiRoutine.failure({ bpId, error: errors }))
    toast.error('Could not load wiki article')
  } finally {
    yield put(fetchWikiRoutine.fulfill({ bpId }))
  }
}

function* refreshWikiSaga({ payload }) {
  const { bpId } = payload || {}
  try {
    yield put(refreshWikiRoutine.request({ bpId }))
    yield call(wikiService.refreshWiki, { bpId })
    yield put(refreshWikiRoutine.success({ bpId }))
    toast.info('Wiki refresh queued — it will update shortly.')
  } catch (err) {
    const errors = getApiErrors(err)
    if (err?.response?.status === 429) {
      const message = err.response.data?.error
        || 'Manual wiki refreshes are limited to once per 24 hours.'
      const nextAllowed = err.response.data?.nextAllowedAt
        || err.response.data?.next_allowed_at
      yield put(refreshWikiRoutine.failure({ bpId, error: errors, nextAllowed }))
      toast.warning(message)
    } else if (err?.response?.status === 409) {
      yield put(refreshWikiRoutine.failure({ bpId, error: errors }))
      toast.info('A wiki regeneration is already in progress — sit tight.')
    } else {
      yield put(refreshWikiRoutine.failure({ bpId, error: errors }))
      toast.error('Could not refresh wiki')
    }
  } finally {
    yield put(refreshWikiRoutine.fulfill({ bpId }))
  }
}

export default function* watchBuildingWiki() {
  yield takeLatest(fetchWikiRoutine.TRIGGER, fetchWikiSaga)
  yield takeLatest(refreshWikiRoutine.TRIGGER, refreshWikiSaga)
}
